/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';

import { BranchLabel } from 'src/sections/repository/sections/pull-request/components/branches-and-state.style';

export const MergeButton = styled(Button)<any>({
  marginRight: `${gridSize()}px`,
});

export const MergeDialogActions = styled.div({
  justifyContent: 'flex-end',
});

export const MergeErrorMessage = styled.div({
  marginTop: `${gridSize() / 2}px`,
  display: 'flex',
  alignItems: 'center',
});

export const ButtonContent = styled.div({
  position: 'relative',
});

export const InnerButtonText = styled.span<{ isDisabled: boolean }>`
  ${props => (props.isDisabled ? 'visibility: hidden' : '')};
`;

export const MergeSpinner = styled.span({
  minWidth: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: `${gridSize() / 2}px`,
});

export const RepositoryOrRef = styled(BranchLabel)({
  marginRight: `${gridSize()}px`,
  maxWidth: 'inherit',
});

export const CommitMessageInputContainer = styled.div({
  marginTop: `${gridSize() * 2.5}px`,
});
